import { readContract, writeContractAndWait } from "../viem";
import config from "../../config/config";

import MafiaJailAbi from "../../abis/MafiaJail.json";

const address = config.jailAddress;
const abi = MafiaJailAbi;

export const isUserInJail = async (userAddress: string) => {
  const isInJail = await readContract({
    address,
    abi,
    functionName: "isUserInJail",
    args: [userAddress],
  });
  return isInJail;
};

export const getJailedUntil = async (userAddress: string) => {
  const jailedUntilTime = await readContract<string>({
    address,
    abi,
    functionName: "jailedUntil",
    args: [userAddress],
  });
  return Number(jailedUntilTime);
};

export const getCrimeType = async (userAddress: string) => {
  const crimeType = await readContract<string>({
    address,
    abi,
    functionName: "prisonerCrimeType",
    args: [userAddress],
  });
  return Number(crimeType);
};

export const buyOut = async (userAddress: string, account: string) => {
  const buyOut = await writeContractAndWait({
    address,
    abi,
    functionName: "buyOut",
    args: [userAddress],
    account,
    gasMultiplier: 5,
  });
  return buyOut;
};

export const bustOut = async (userAddress: string, account: string) => {
  const bustOut = await writeContractAndWait({
    address,
    abi,
    functionName: "bustOut",
    args: [userAddress],
    account,
    gasMultiplier: 5,
  });
  return bustOut;
};

export const getBustOutInfo = async (userAddress: string) => {
  const bustOutInfo = await readContract({
    address,
    abi,
    functionName: "bustOutInfo",
    args: [userAddress],
  });
  return bustOutInfo;
};

export const getNextBustOutTime = async (userAddress: string) => {
  const nextBustOutTime: number = await readContract({
    address,
    abi,
    functionName: "nextBustOutTime",
    args: [userAddress],
  });
  return Number(nextBustOutTime);
};
